module.exports =
  mouseevents: 60
  transitions: 600
  ui:          200
